import {h, Fragment} from "preact"
import { useProductFilters } from "@nosto/preact"

function FilterRemoveButton({ filter }) {
    return (
        <span
            className={`filter-group__applied-item__icon`}
            onClick={() => filter.remove()}
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>
        </span>
    )
}

export default function SelectedFilters() {
    const { filters, removeAll } = useProductFilters()

    return (
        filters.length > 0 && (
            <div class="filter-group filter-group--applied">
                <div class="filter-group__heading">
                    <div class="filter-group__heading__text">Applied filters</div>
                </div>
                <div class="filter-group__items">
                    {filters.map(filter => (
                        <div
                            key={`${filter.value}`}
                            class="filter-group__applied-item"
                        >
                            <span class="filter-group__applied-item__text">{filter.value}</span>
                            <FilterRemoveButton filter={filter} />
                        </div>
                    ))}
                </div>
                <span
                    class="filter-group__clear-row"
                    onClick={() => {
                        removeAll()
                    }}
                >
                    <span class="filter-group__clear-link">Clear all</span>
                </span>
            </div>
        )
    )
}
